<template><div>ds</div></template>
<script>
export default {
  created() {
    window.location = "/calls";
  },
};
</script>
